export default `#define M(p)p=vec2(sin(atan(p.x,p.y)*4.)/3.,1)*length(p),p.y-=2.
    float i,g,e,s;
    for(s=3.;s<4e4;s*=3.)
      M(p.xy),
      M(p.zy),
      p*=3.;
    return length(p.xy)/s-.001;
  }`